import { Avatar, Box, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import { useRecordContext } from 'react-admin';

export interface MissionVisibilityLightCardRecord {
    id: string;
    name: string;
    icon?: SvgIconComponent;
}

export const MissionVisibilityLightCard = (props: {
    record?: MissionVisibilityLightCardRecord;
}) => {
    const record = useRecordContext<MissionVisibilityLightCardRecord>(props);
    const Icon = record?.icon;

    return (
        <Box display="flex" alignItems="center" gap={0.5}>
            <Avatar
                variant="rounded"
                sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 1,
                    bgcolor: 'transparent',
                }}
            >
                {Icon ? (
                    <Icon sx={{ fontSize: 20, color: 'black' }} />
                ) : (
                    (record?.name ?? '').charAt(0).toUpperCase()
                )}
            </Avatar>
            <Typography variant="body2" noWrap>
                {record?.name}
            </Typography>
        </Box>
    );
};
